import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Paper, TextField, Typography } from '@mui/material';
import { Organization } from 'models/organization';
import AddressForm from 'components/shared/address/address-form.component';

type ClinicInvoiceContentProps = {
    clinic: Organization;
};
const ClinicInvoiceContent: FC<ClinicInvoiceContentProps> = ({ clinic }: ClinicInvoiceContentProps) => {
    const { t: translate } = useTranslation(['organization', 'client-directory', 'organization-numbers']);

    return (
        <Paper>
            <Box p={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label={translate('organization:ORGANIZATION_OFFICIAL_NAME')}
                            variant="standard"
                            value={clinic.officialName}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12} sm={4}>
                        <TextField
                            label={translate(
                                `organization-numbers:${clinic.invoicing?.invoiceAddress?.country || 'SE'}_ORGANIZATION_NUMBER`,
                            )}
                            variant="standard"
                            value={clinic.organizationNumber || ' '}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label={translate('client-directory:COST_CENTER')}
                            variant="standard"
                            value={clinic.invoicing?.costCenter || ' '}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            label={translate('client-directory:GLN')}
                            variant="standard"
                            value={clinic.gln || ' '}
                            inputProps={{ readOnly: true }}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <AddressForm
                            address={clinic.invoicing?.invoiceAddress || clinic.contact?.address}
                            disableChageAddress
                            title={translate('client-directory:INVOICE_ADDRESS')}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
};

export default ClinicInvoiceContent;
